export const {
  PUBLIC_URL,
  REACT_APP_ACCESS_TOKEN_NAME,
  REACT_APP_ACCESS_TOKEN_NAME_MP,
  REACT_APP_API_BASE_BUYER_URL,
  REACT_APP_API_BASE_SELLER_URL,
  REACT_APP_BASE_URL,
  REACT_APP_CAPACITACION_BASE_URL,
  REACT_APP_CAPTCHA_ENABLED,
  REACT_APP_CAPTCHA_SITE_KEY,
  REACT_APP_CENTROAYUDA_BASE_URL,
  REACT_APP_CHILECOMPRA_BASE_URL,
  REACT_APP_CONTACT_URL,
  REACT_APP_ENVIRONMENT,
  REACT_APP_FACEBOOK_URL,
  REACT_APP_FEATURE_FLAG_SEARCH_ENGINE,
  REACT_APP_FIRTS_NUMBER,
  REACT_APP_GOOGLE_ANALYTICS_KEY = null,
  REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION = null,
  REACT_APP_GOOGLE_TASK_MANAGER_KEY = null,
  REACT_APP_HOTJAR_ID = null,
  REACT_APP_HOTJAR_SNIPPET_VERSION = null,
  REACT_APP_INSTAGRAM_URL,
  REACT_APP_LINKEDIN_URL,
  REACT_APP_MERCADO_PUBLICO_BASE_URL,
  REACT_APP_OPENED_DATA_URL,
  REACT_APP_PUBLIC_MARKET_API_URL,
  REACT_APP_REGISTRARME_URL,
  REACT_APP_SECOND_NUMBER,
  REACT_APP_SELLER_SEARCH_URL,
  REACT_APP_TERMS_AND_CONDITIONS_URL,
  REACT_APP_TWITTER_URL,
  REACT_APP_YOUTUBE_URL
} = process.env
export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod'
export const isLocalEnv = process.env.REACT_APP_ENVIRONMENT === 'local'
